import { type ReduxUser } from 'models';
import { canManageProgramRedux } from './canManageProgram';

export const canDeleteProgramMemberRedux = ({ viewer, program }: { viewer: ReduxUser; program: any }) =>
  canManageProgramRedux({ viewer, program });
